import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const ListPaginationStyle = styled.div`
  width: 100%;

  .list-pagination-container {
    text-align: center;

    .list-pagination-button {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.grayishBlue};
      display: inline-block;
      font-size: 12px;
      line-height: 15px;
      margin-right: 12px;

      &.step-page-button {
        &:disabled {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.grayishBlue};
          opacity: 0.25;
        }
      }

      &:disabled {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.softBlue};
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;
